<template>
  <!-- 课程详情页 -->
  <div class="coursedetailspage">
    <div class="details-box">
      <div class="box">
        <p align="left" class="details-nav">
          当前位置： <span @click="homes"> 首页</span>>
          <span @click="myinformation()">{{ "健康科普" }}</span
          >>{{ teps.name }}
        </p>
        <div class="Videocontent">
          <video
            :src="htto + teps.video"
            controls="controls"
            @timeupdate="updateTime"
            class="imgs"
            ref="videoPlay"
          ></video>
          <div class="right-Video">
            <div class="right-Video-title">
              <h4>{{ teps.name }}</h4>
              <div style="display: flex; width: 350px">
                <img
                  style="margin-left: 30px"
                  src="../../assets/medal.png"
                  alt=""
                />
                <span>{{ teps.score }}</span>
                <p>科普评分</p>
                <!-- <el-rate   v-model="pfs"
              @change="insrateis(pfs)"
              :colors="colors"> </el-rate> -->
                <div class="block">
                  <el-rate
                    v-model="pfs"
                    :colors="['#99A9BF', '#F7BA2A', '#FF9900']"
                    @change="insrateis(pfs)"
                    disabled
                  ></el-rate>
                </div>
              </div>
            </div>
            <div class="right-Video-teacher">
              <span class="right-talker"> 讲述人： </span>
              <!-- <img @click="teacherjump(teps)" class="Headportrait" :src="htto+teps.jsjs.tx" alt="" /> -->
              <span @click="teacherjump(teps)" class="right-teacher">
                {{ teps.user.name }}
              </span>
              <span class="right-buy" v-if="teps.jg !== '免费'">
                | &nbsp; &nbsp;&nbsp;500购买
              </span>
              <i
                style="
                  width: 16px;
                  height: 10px;
                  line-height: 21px;
                  margin-left: 76px;
                "
                class="iconfont"
              ></i>
              <span class="right-views">
                <i class="iconfont gos-yanjing1"></i>
                浏览量：{{ teps.ll }}</span
              >
              <span :class="[setz ? 'buts' : 'sizsa']">
                <i class="iconfont gos-aixin"> </i>
                <span class="right-collection">收藏：{{ teps.sc }}</span>
              </span>
              <span class="scrq">上传日期：{{ teps.knowdate }}</span>
            </div>
            <div class="Theprice">
              <span class="free">{{ "免费" }}</span>
              <!-- <p class="The-price" v-if="teps.jg !== '免费'">
                价格：
                <span style="color: #ff1010; text-decoration: line-through"
                  >￥99.0</span
                >
              </p>
              <p class="Present-price" v-if="teps.jg !== '免费'">
                现价：
                <span class="priceprice"> ￥69.0 </span>
              </p>
              <div class="timelimit" v-if="teps.jg !== '免费'">
                限时特惠 立减 <span>30</span> 元！
              </div> -->
            </div>
            <div class="buttom">
              <!-- <el-button v-if="teps.jg !== '免费'" type="primary"
                >免费试听</el-button
              >
              <el-button v-if="teps.jg !== '免费'" type="primary"
                >立即购买</el-button
              > -->
              <el-button type="primary" @click="plays()">立即播放</el-button>
              <el-button @click="inscollects(teps)" type="primary">
                {{ setz ? "取消收藏" : "收藏" }}</el-button
              >
              <el-button @click="inslikes(teps)" type="primary">
                {{ setdz ? "取消点赞" : "点赞" }}</el-button
              >
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="sthecolor">
      <div class="zonghe">
        <div>
          <el-menu
            :default-active="activeIndex || activeMenu"
            class="el-menu-demoss"
            @select="handleSelect"
            router
          >
            <el-menu-item index="/PopularIntroduction"
              ><span> 课程介绍 </span></el-menu-item
            >
            <el-menu-item index="/DoctorIntroduction">医生介绍</el-menu-item>
            <!-- <el-menu-item index="/AboutInstructor">软件下载</el-menu-item> -->
            <!-- <el-menu-item index="/Instructionsfor">操作说明</el-menu-item> -->
            <el-menu-item index="/PopularReview">科普评论</el-menu-item>
            <el-menu-item
              index="/ReviewScore"
              v-if="$store.state.user.dentitys == '评委员'"
              >评审得分</el-menu-item
            >
          </el-menu>

          <div class="line">
            <router-view />
          </div>
        </div>
        <div class="right">
          <div class="overview">
            <h5 class="isintroduced">讲师</h5>
            <div class="Isthecolor">
              <img
                class="portrait"
                :src="htto + teps.user.tx"
                @click="teacherjump(teps)"
              />
              <div class="portraitname">
                <h5 style="cursor: pointer" @click="teacherjump(teps)">
                  {{ teps.user.name }}
                </h5>
                <div
                  class="location"
                  style="cursor: pointer"
                  @click="teacherjump(teps)"
                >
                  <img src="../../assets/The-title.png" alt="" />
                  <span v-for="(item, index) in teps.user.userzc" :key="index">
                    <span v-if="index === 0">{{ item.zcname }} </span></span
                  >
                </div>
              </div>
            </div>
            <div class="Favorable">
              <li style="margin-right: 37px">
                <h4>总好评度</h4>
                <p>{{ jsxqsl.kczhpd }}%</p>
              </li>
              <li style="margin-right: 37px">
                <h4>课程数</h4>
                <p>{{ jsxqsl.kcs }}</p>
              </li>
              <li>
                <h4>学习人数</h4>
                <p>{{ jsxqsl.xxrs }}</p>
              </li>
            </div>
          </div>
          <div class="Theheader-two">
            <h5 class="isintroduced">科普列表</h5>
            <div class="inform-two">
              <ul>
                <li
                  class="Popularity"
                  v-for="(item, index) in Popularity"
                  :key="item.id"
                  @click="jump(item)"
                >
                  <img
                    v-if="index === 0"
                    src="../../assets/trophy1.png"
                    alt=""
                  />
                  <img
                    v-if="index === 1"
                    src="../../assets/Popularity2.png"
                    alt=""
                  />
                  <img
                    v-if="index === 2"
                    src="../../assets/Popularity3.png"
                    alt=""
                  />
                  <div v-if="index > 2">{{ index + 1 }}</div>
                  <p>{{ item.name }}</p>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  selknownumber,
  selknow,
  insrate,
  selrate,
  insknownumber,
  insreodrd,
  seljsxx,
  updll,
  delknownumber,
} from "../../api/patient";
import Bus from "@/utils/bus";
export default {
  data() {
    return {
      jsxqsl: "",
      Popularity: "",
      setz: false,
      setzid: "",
      setdz: false,
      setdzid: "",
      pfs: 0,
      teps: {
        video: "",
        gm: "",
        id: "",
        itemtime: "",
        jg: "",
        jsjs: "",
        kcjs: "",
        ll: "",
        name: "",
        pf: "",
        plcyrs: "",
        plts: "",
        rjxz: {
          bhrjbb: [],
          id: "",
          rjjj: "",
          rjlb: "",
          rjmc: "",
          rjsm: "",
          rjsm1: "",
          rjsp: "",
          rjsp1: "",
          rjtb: "",
          rjtb1: "",
          softwaretime: "",
        },
        sc: "",
        scrq: "",
        softwareid: "",
        sort: "",
        sp: "",
        sp1: "",
        status: "",
        tsy: "",
        userid: "",
        xj: "",
      },
      htto: this.$store.state.https,
      activeIndex: "",

      // value: 4.5,
      colors: ["#F86626", "#F86626", "#F86626"],
      aryys: {},
    };
  },
  async created() {
    await this.selitemis();
    await this.selitemiss();
    // await this.seljsxxix(this.teps.jsjs.id);
    // this.activeIndex = this.$store.state.rutset
  },
  mounted() {
    Bus.$emit("activeRouter", "/HealthSciencePopularization");
  },

  computed: {
    activeMenu() {
      const route = this.$route;
      const { meta, path } = route;
      if (meta.activeMenu) {
        return meta.activeMenu;
      }
      return path;
    },
  },
  methods: {
    homes() {
      this.$router.push("/home");
    },
    myinformation() {
      if (this.$store.state.hometz === 1) {
        this.$router.push("/home");
      } else {
        this.$router.push("/HealthSciencePopularization");
      }
    },

    // 获取老师详细信息
    seljsxxix(item) {
      var data = new FormData();
      data.append("id", item);
      seljsxx(data).then((res) => {
        this.jsxqsl = res;
      });
    },
    // 跳转到详情页课程
    jump(item) {
      this.$store.commit("Jumpfordetails", item.id);
      if (item.sorts == "视频") {
        // this.$router.push("/PopularScienceDetails");
        this.teps = item;
      } else {
        this.$router.push("/ArticleDetails");
      }
      location.reload();
      window.scrollTo({
        top: 1,
      });
    },
    // 人气排行
    async selitemiss() {
      var data = new FormData();
      data.append("page", 1);
      data.append("rows", 9);
      data.append("sta", "浏览");
      data.append("status", "已通过");
      await selknow(data).then((res) => {
        console.log(res);
        this.Popularity = res.records;
      });
    },
    // 跳转老师详情页
    teacherjump(item) {
      this.$router.push(`/TeacherDetailsPage/${item.jsjs.id}`);
    },
    // 添加学习记录
    insreodrdis(item) {
      if (this.$store.state.isLogin) {
        var data = new FormData();
        data.append("userid", this.$store.state.user.id);
        data.append("itemid", item.id);
        insreodrd(data).then((res) => {});
      } else {
        this.$message({
          showClose: true,
          message: "请先进行登录",
          type: "warning",
        });
      }
    },
    // 获取收藏状态
    selcollectis(item) {
      if (this.$store.state.isLogin) {
        var data = new FormData();
        data.append("page", 1);
        data.append("rows", 1);
        data.append("phone", this.$store.state.user.phone);
        data.append("sort", "收藏");
        data.append("kid", item.id);
        selknownumber(data).then((res) => {
          if (res.totalCount !== 0) {
            this.setz = true;
            this.setzid = res.records[0].id;
          }
        });
      }
    },
    // 获取点赞状态
    sellikes(item) {
      if (this.$store.state.isLogin) {
        var data = new FormData();
        data.append("page", 1);
        data.append("rows", 1);
        data.append("phone", this.$store.state.user.phone);
        data.append("sort", "点赞");
        data.append("kid", item.id);
        selknownumber(data).then((res) => {
          if (res.totalCount !== 0) {
            this.setdz = true;
            this.setdzid = res.records[0].id;
          }
        });
      }
    },
    // 用户点赞与取消点赞
    inslikes(item) {
      if (this.$store.state.isLogin) {
        var data = new FormData();
        if (this.setdz == false) {
          data.append("phone", this.$store.state.user.phone);
          data.append("kid", item.id);
          data.append("sort", "点赞");
          insknownumber(data).then((res) => {
            if (res.code === "OK") {
              this.$message({
                showClose: true,
                message: res.msg,
                type: "success",
              });
              this.setdz = true;
              this.selitemis();
            }
          });
        } else {
          data.append("ids", this.setdzid);
          delknownumber(data).then((res) => {
            if (res.code === "OK") {
              this.$message({
                showClose: true,
                message: res.msg,
                type: "success",
              });
              this.setdz = false;
              this.selitemis();
            }
          });
        }
      } else {
        this.$message({
          showClose: true,
          message: "请先进行登录",
          type: "warning",
        });
      }
    },
    // 用户收藏与取消收藏
    inscollects(item) {
      if (this.$store.state.isLogin) {
        var data = new FormData();
        if (this.setz == false) {
          data.append("phone", this.$store.state.user.phone);
          data.append("kid", item.id);
          data.append("sort", "收藏");
          insknownumber(data).then((res) => {
            if (res.code === "OK") {
              this.$message({
                showClose: true,
                message: res.msg,
                type: "success",
              });
              this.setz = true;
              this.selitemis();
            }
          });
        } else {
          data.append("ids", this.setzid);
          delknownumber(data).then((res) => {
            if (res.code === "OK") {
              this.$message({
                showClose: true,
                message: res.msg,
                type: "success",
              });
              this.setz = false;
              this.selitemis();
            }
          });
        }
      } else {
        this.$message({
          showClose: true,
          message: "请先进行登录",
          type: "warning",
        });
      }
    },
    // 获取评分
    selrateis() {
      if (this.$store.state.isLogin) {
        var data = new FormData();
        data.append("itemid", this.teps.id);
        data.append("userid", this.$store.state.user.id);
        selrate(data).then((res) => {
          this.pfs = Number(res.rate);
        });
      }
    },
    // 评分页面
    insrateis(rre) {
      if (this.$store.state.isLogin) {
        var data = new FormData();
        data.append("rate", rre);
        data.append("itemid", this.teps.id);
        data.append("userid", this.$store.state.user.id);
        insrate(data).then((res) => {
          if (res.code === "OK") {
            this.$message({
              showClose: true,
              message: res.msg,
              type: "success",
            });
            this.selitemis();
          }
        });
      } else {
        this.pfs = 0;
        this.$message({
          showClose: true,
          message: "请先进行登录",
          type: "warning",
        });
      }
    },
    // 立即播放
    plays() {
      this.$refs.videoPlay.play();
      // this.insreodrdis(this.teps)
    },
    // 获取列表
    async selitemis() {
      const data = new FormData();
      data.append("id", this.$store.state.Jumpid);
      await selknow(data).then((res) => {
        this.teps = res;
        this.teps.score = Number(this.teps.score);
        // sessionStorage.setItem("itemss", JSON.stringify(res));
        // this.selrateis();
        this.$store.commit("kpwzxx", this.teps);
        this.selcollectis(this.teps);
        setTimeout(() => {
          this.sellikes(this.teps);
        }, 500);
        // console.log(this.teps, "1");
        this.seljsxxix(this.teps.user.id);
      });
    },
    // 导航栏回调
    handleSelect(key, keyPath) {
      this.$store.commit("subset", key);
    },
    updateTime() {
      const a = Number(this.$refs.videoPlay.currentTime);
      if (Number(a) > 3 && Number(a) < 5) {
        if (this.$store.state.isLogin === true) {
          var data = new FormData();
          data.append("kid", this.$store.state.Jumpid);
          data.append("phone", this.$store.state.user.phone);
          data.append("sort", "浏览");
          insknownumber(data).then((res) => {});
        }
      }
    },
  },
  destroyed() {
    var data = new FormData();
    data.append("id", this.$store.state.Jumpid);
    updll(data).then((res) => {});
    this.$store.commit("homres", 0);
  },
};
</script>
<style lang="scss" scoped>
.coursedetailspage {
  margin-top: 9px;
  width: 100%;
  background: #fff;
  .details-box {
    width: 1090px;
    margin: auto;
    padding-left: 50px;
    padding-right: 50px;
    padding-bottom: 31px;
    // margin-bottom: 9px;

    .box {
      margin-left: 20px;
      .details-nav {
        padding-top: 23px;
        font-size: 14px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #000;
        cursor: pointer;
      }
      .Videocontent {
        display: flex;
        text-align: left;
        margin-top: 24px;
        // width: 1001px;
        .imgs {
          width: 314px;
          height: 191px;
          // border-radius: 6px;
        }
        .right-Video {
          padding-left: 21px;
          .right-Video-title {
            display: flex;
            h4 {
              font-size: 20px;
              font-family: Source Han Sans CN;
              font-weight: 400;
              color: #333333;
            }
            img {
              margin-left: 12px;
              width: 16px;
              height: 20px;
              margin-top: 5px;
            }
            span {
              margin-left: 10px;
              font-size: 20px;
              font-family: Source Han Sans CN;
              font-weight: bold;
              color: #f86626;
            }
            p {
              font-size: 14px;
              font-family: Source Han Sans CN;
              font-weight: 400;
              color: #333333;
              line-height: 32px;
              margin-left: 39px;
            }
            .el-rate {
              font-size: 0px;
              margin-left: 11px;
              line-height: 40px;

              .el-rate__item {
                width: 18px;
                height: 18px;
              }
            }
          }
        }
      }
      .right-Video-teacher {
        margin-top: 10px;
        display: flex;
        white-space: nowrap;
        font-size: 14px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #999999;
        .right-talker {
          margin-right: 8px;
        }
        img {
          margin-right: 5px;
        }
        .right-teacher {
          margin-right: 12px;
        }
        .right-buy {
          margin-left: 12px;
        }
        .right-views {
          margin-left: 10px;
          margin-right: 31px;
        }
        .right-collection {
          margin-left: 10px;
          margin-right: 21px;
        }
      }
    }
  }
}
.Theprice {
  // width: 667px;
  margin-top: 17px;
  display: flex;
  height: 49px;
  background: #f6f6f6;
  border-radius: 6px;
  line-height: 49px;
  padding-left: 17px;
  .The-price {
    font-size: 16px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    // text-decoration: line-through;
    color: #999999;
  }
}
.Present-price {
  font-size: 16px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #999999;
  margin-left: 25px;
  margin-right: 25px;
  .priceprice {
    color: #ff1010;
  }
}
.timelimit {
  font-size: 16px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #999999;
}
.buttom {
  button {
    margin-top: 20px;
    width: 105px;
    height: 35px;
    padding: 0px;
    background: #4ccaff;
    border: 0;
  }

  button:hover {
    background: #4ccaffc9;
  }
}
.el-menu-demo {
  margin-top: 9px;
  width: 744px;
}

.Headportrait {
  width: 22px;
  height: 22px;
  border-radius: 50%;
}
.free {
  font-size: 16px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #ff3939;
}
.buts {
  color: #4ccaff;
}
.sizsa {
  color: #999999;
}
.jsdhusoia {
  height: 16px;
}
.line {
  width: 744px;
  min-height: 500px;
  padding-bottom: 70px;
  display: flex;
  background: #fff;
}
.zonghe {
  display: flex;
  width: 1090px;
  margin: auto;
  margin-bottom: 10px;

  .right {
    margin-top: 9px;
    // margin-left: 11px;
    width: 287px;
  }
}
.portrait {
  width: 45px;
  height: 45px;
  border-radius: 50%;
  cursor: pointer;
  // background:red;
}
.Isthecolor {
  display: flex;
  margin-left: 40px;
}
.overview {
  background: #ffffff;
  border-radius: 6px;
  display: flex;
  margin-left: 11px;
  flex-direction: column;

  .portraitname {
    margin-left: 12px;
    h5 {
      font-size: 14px;
      margin-top: 4px;
      text-align: left;
      margin-bottom: 5px;
    }
    .location {
      // height: 15px;
      font-size: 12px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #333333;
      img {
        margin-right: 9px;
        width: 14px;
        height: 14px;
      }
      span {
        line-height: 12px;
      }
    }
  }
}
.sthecolor {
  width: 100%;
  margin-top: 9px;
  background: #f8fafc;
}
.isintroduced {
  text-align: left;
  margin-left: 21px;
  // margin-top: 2px;
  margin-bottom: 22px;
  // width: 56px;
  padding-left: 10px;
  border-left: 2px solid #4ccaff;
  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: bold;
  color: #333333;
}
.Favorable {
  display: flex;
  margin-top: 30px;
  margin-left: 40px;
  margin-bottom: 34px;
  li {
    h4 {
      margin-bottom: 5px;
    }
  }
}
.Theheader-two {
  margin-top: 9px;
  width: 276px;
  margin-left: 9px;
  background: #fff;
  border: 1px solid #f6f6f6;
  border-radius: 6px;
  .isintroduced {
    text-align: left;
    margin-left: 21px;
    // margin-top: 2px;
    margin-bottom: 22px;
    // width: 56px;
    padding-left: 10px;
    border-left: 2px solid #4ccaff;
    font-size: 14px;
    font-family: Source Han Sans CN;
    font-weight: bold;
    color: #333333;
  }
  .inform-two {
    padding-left: 22px;
    .Popularity {
      display: flex;
      margin-bottom: 16px;
      cursor: pointer;
      img {
        width: 19px;
        height: 16px;
        margin-right: 8px;
      }
      div {
        width: 19px;
        height: 16px;
        font-size: 14px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #333333;
        // line-height: px;
        margin-right: 8px;
      }
      p {
        text-align: left;
        width: 210px;
        // height: 14px;
        font-size: 14px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #333333;
        display: -webkit-box; /**对象作为伸缩盒子模型展示**/
        -webkit-box-orient: vertical; /**设置或检索伸缩盒子对象的子元素的排列方式**/
        -webkit-line-clamp: 1; /**显示的行数**/
        overflow: hidden; /**隐藏超出的内容**/
      }
    }
    .Popularity:hover p {
      color: #4ccaff;
    }
  }
}

.el-menu-demoss {
  margin-top: 9px;
  display: flex;

  .el-menu-item {
    border-bottom: 0px solid #4ccaff;
  }
  .is-active {
    color: #4ccaff;
    background: #fff;
    border-bottom: 2px solid #4ccaff;
  }
}

.isintroduced {
  margin-top: 25px;
}
img {
  object-fit: contain;
}
// 适配手机端
@media (max-width: 768px) {
  .coursedetailspage {
    width: 100%;
    .details-box {
      width: 100vw;
      padding-left: 0px;
      padding-right: 0px;
      padding-bottom: 31px;
      .box {
        margin-left: 10px;
        .Videocontent {
          display: block;
          .imgs {
            width: 95vw;
          }
          .right-Video {
            padding-left: 10px;
            .right-Video-title {
              display: block;
              img {
                margin-left: 1px !important;
              }
            }
          }
        }
        .right-Video-teacher {
          margin-top: 10px;
          .right-talker {
            margin-right: 8px;
          }
          img {
            margin-right: 5px;
          }
          .right-teacher {
            margin-right: 12px;
          }
          .right-buy {
            margin-left: 12px;
            display: none;
          }
          .right-views {
            margin-left: 10px;
            margin-right: 31px;
          }
          .right-collection {
            margin-left: 10px;
            margin-right: 21px;
          }
          .scrq {
            display: none;
          }
        }
      }
    }
  }
  .Theprice {
    // width: 667px;
    margin-top: 17px;
    display: flex;
    height: 49px;
    background: #f6f6f6;
    border-radius: 6px;
    line-height: 49px;
    padding-left: 17px;
    .The-price {
      font-size: 16px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      // text-decoration: line-through;
      color: #999999;
    }
  }
  .Present-price {
    font-size: 16px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #999999;
    margin-left: 25px;
    margin-right: 25px;
    .priceprice {
      color: #ff1010;
    }
  }
  .timelimit {
    font-size: 16px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #999999;
  }
  .buttom {
    button {
      margin-top: 20px;
      width: 105px;
      height: 35px;
      padding: 0px;
      background: #4ccaff;
      border: 0;
    }

    button:hover {
      background: #4ccaffc9;
    }
  }
  .el-menu-demo {
    margin-top: 9px;
    width: 744px;
  }

  .Headportrait {
    width: 22px;
    height: 22px;
    border-radius: 50%;
  }
  .free {
    font-size: 16px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #ff3939;
  }
  .buts {
    display: none;
  }
  .sizsa {
    display: none;
  }
  .jsdhusoia {
    height: 16px;
  }
  .line {
    width: 100vw;
    min-height: 500px;
    padding-bottom: 70px;
    display: flex;
    background: #fff;
  }
  .zonghe {
    display: flex;
    width: 100vw;
    margin: auto;
    margin-bottom: 10px;

    .right {
      display: none;
    }
  }
  .portrait {
    width: 45px;
    height: 45px;
    border-radius: 50%;
    cursor: pointer;
    // background:red;
  }
  .Isthecolor {
    display: flex;
    margin-left: 40px;
  }
  .overview {
    background: #ffffff;
    border-radius: 6px;
    display: flex;
    margin-left: 11px;
    flex-direction: column;

    .portraitname {
      margin-left: 12px;
      h5 {
        font-size: 14px;
        margin-top: 4px;
        text-align: left;
        margin-bottom: 5px;
      }
      .location {
        // height: 15px;
        font-size: 12px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #333333;
        img {
          margin-right: 9px;
          width: 14px;
          height: 14px;
        }
        span {
          line-height: 12px;
        }
      }
    }
  }
  .sthecolor {
    width: 100%;
  }
  .isintroduced {
    text-align: left;
    margin-left: 21px;
    // margin-top: 2px;
    margin-bottom: 22px;
    // width: 56px;
    padding-left: 10px;
    border-left: 2px solid #4ccaff;
    font-size: 14px;
    font-family: Source Han Sans CN;
    font-weight: bold;
    color: #333333;
  }
  .Favorable {
    display: flex;
    margin-top: 30px;
    margin-left: 40px;
    margin-bottom: 34px;
    li {
      h4 {
        margin-bottom: 5px;
      }
    }
  }
  .Theheader-two {
    margin-top: 9px;
    width: 276px;
    margin-left: 9px;
    background: #fff;
    border: 1px solid #f6f6f6;
    border-radius: 6px;
    .isintroduced {
      text-align: left;
      margin-left: 21px;
      // margin-top: 2px;
      margin-bottom: 22px;
      // width: 56px;
      padding-left: 10px;
      border-left: 2px solid #4ccaff;
      font-size: 14px;
      font-family: Source Han Sans CN;
      font-weight: bold;
      color: #333333;
    }
    .inform-two {
      padding-left: 22px;
      .Popularity {
        display: flex;
        margin-bottom: 16px;
        cursor: pointer;
        img {
          width: 19px;
          height: 16px;
          margin-right: 8px;
        }
        div {
          width: 19px;
          height: 16px;
          font-size: 14px;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: #333333;
          // line-height: px;
          margin-right: 8px;
        }
        p {
          text-align: left;
          width: 210px;
          // height: 14px;
          font-size: 14px;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: #333333;
          display: -webkit-box; /**对象作为伸缩盒子模型展示**/
          -webkit-box-orient: vertical; /**设置或检索伸缩盒子对象的子元素的排列方式**/
          -webkit-line-clamp: 1; /**显示的行数**/
          overflow: hidden; /**隐藏超出的内容**/
        }
      }
      .Popularity:hover p {
        color: #4ccaff;
      }
    }
  }

  .el-menu-demoss {
    margin-top: 9px;
    display: flex;

    .el-menu-item {
      border-bottom: 0px solid #4ccaff;
    }
    .is-active {
      color: #4ccaff;
      background: #fff;
      border-bottom: 2px solid #4ccaff;
    }
  }

  .isintroduced {
    margin-top: 25px;
  }
  img {
    object-fit: contain;
  }
}
</style>
